module.exports = __webpack_public_path__ + "img/ic_home.6b84eefa.svg";